import { getRequest } from 'src/state/utils'

export const getPlans: RequestTypeVariable = {
  getKey: (id: string) => ['getPlans', id],
  request: async (id: string): Promise<Plan[]> => {
    const { data } = await getRequest<Plan[]>({
      url: `/projects/${id}/plans`,
    })

    return data as Plan[]
  },
}

export const getDriveTemplates: RequestTypeVariable = {
  getKey: (id: string) => ['getDriveTemplates', id],
  request: async (projectId): Promise<DriveTemplate[] | null> => {
    const { data } = await getRequest<DriveTemplate[]>({
      url: `/projects/${projectId}/plans/templates`,
    })

    return data
  },
}

export const getPdfPlanSettings: RequestTypeVariable = {
  getKey: (id: string) => ['getPdfPlanSettings', id],
  request: async (id: string): Promise<PdfPlanSettings> => {
    const { data } = await getRequest<PdfPlanSettings>({
      url: `/projects/${id}/export/pdf-plan-settings`,
    })
    return data as PdfPlanSettings
  },
}
